module.exports = __webpack_public_path__ + "components/page-header/static/icon-caret-right-b1d3f72f2de208957637db8f2871940e.svg";